var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 249 250",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.237 186.264l-16.884 42.51 42.516-16.878L228.526 46.238c7.061-7.07 7.061-18.562 0-25.632-7.074-7.07-18.572-7.06-25.637 0L37.237 186.264zM7.308 249.126a7.292 7.292 0 01-5.166-2.14 7.317 7.317 0 01-1.627-7.87l23.697-59.655a7.365 7.365 0 011.627-2.465L192.556 10.273c12.38-12.368 33.944-12.36 46.303 0 12.76 12.769 12.76 33.53 0 46.298L72.136 223.294a7.387 7.387 0 01-2.469 1.627l-59.66 23.692a7.408 7.408 0 01-2.699.513z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.956 69.444a7.282 7.282 0 01-5.167-2.141l-35.97-35.964a7.307 7.307 0 0110.333-10.333l35.97 35.964a7.304 7.304 0 010 10.333 7.28 7.28 0 01-5.166 2.14M66.97 225.435a7.28 7.28 0 01-5.166-2.141L25.837 187.33a7.305 7.305 0 010-10.333 7.304 7.304 0 0110.332 0l35.966 35.965a7.304 7.304 0 010 10.332 7.282 7.282 0 01-5.166 2.14"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.8e7688bf5e47b925133079345d942c79.svg";
export { ForwardRef as ReactComponent };